import React, {useCallback, useState} from 'react';
import {
  ReactFlow,
  addEdge,
  useNodesState,
  useEdgesState,
  Controls,
  getSmoothStepPath,
  Background,
  MiniMap,
  EdgeProps,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import {number} from 'prop-types';

const initialNodes = [
  {id: '1', position: {x: 100, y: 100}, data: {label: 'Node 1'}},
  {id: '2', position: {x: 400, y: 300}, data: {label: 'Node 2'}},
];

const initialEdges = [
  {
    id: 'e1-2',
    source: '1',
    target: '2',
    type: 'customStepEdge',
    data: {controlX: 250, controlY: 200}, // Initial control point
  },
];

// const CustomStepEdge = (props: EdgeProps) => {
//     const {id, sourceX, sourceY, targetX, targetY, data, markerEnd, } = props;
//   const [control, setControl] = useState({x: data.controlX, y: data.controlY});

//   // Handle control point drag
//   const onDrag = event => {
//     setControl({x: event.clientX, y: event.clientY});
//   };

//   // Generate a step path using control points
//   const [edgePath] = getSmoothStepPath({
//     sourceX,
//     sourceY,
//     targetX,
//     targetY,
//     centerX: control.x,
//     centerY: control.y,
//   });

//   return (
//     <>
//       {/* Draw the step path */}
//       <path d={edgePath} fill="none" stroke="black" strokeWidth={2} markerEnd={markerEnd} />

//       {/* Draggable control point */}
//       <circle
//         cx={control.x}
//         cy={control.y}
//         r={8}
//         fill="blue"
//         stroke="white"
//         strokeWidth={2}
//         style={{cursor: 'grab'}}
//         onMouseDown={event => event.preventDefault()}
//         onPointerDown={event => {
//           event.target.setPointerCapture(event.pointerId);
//           event.target.onpointermove = onDrag;
//           event.target.onpointerup = () => (event.target.onpointermove = null);
//         }}
//       />
//     </>
//   );
// };

const CustomStepEdge = ({id, sourceX, sourceY, targetX, targetY, data, markerEnd}: EdgeProps) => {
  const [control, setControl] = useState<{x: number; y: number}>({
    x: (sourceX + targetX) / 2,
    y: (sourceY + targetY) / 2,
  });

  const onDrag = (event: PointerEvent) => {
    setControl({x: event.clientX, y: event.clientY});
  };

  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    centerX: control.x,
    centerY: control.y,
  });

  return (
    <>
      <path id={id} d={edgePath} fill="none" stroke="#222" strokeWidth={2} markerEnd={markerEnd} />
      <circle
        cx={control.x}
        cy={control.y}
        r={5}
        fill="#fff"
        stroke="#222"
        strokeWidth={2}
        cursor="move"
        onPointerDown={event => {
          event.preventDefault();
          const target = event.target as SVGCircleElement;
          target.setPointerCapture(event.pointerId);
          target.onpointermove = onDrag as unknown as (
            event: SVGElementEventMap['pointermove'],
          ) => void;
          target.onpointerup = () => (target.onpointermove = null);
        }}
      />
    </>
  );
};

const edgeTypes = {customStepEdge: CustomStepEdge};

const EditableStepEdgeFlow = () => {
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

  const onConnect = useCallback(
    params =>
      setEdges(eds =>
        addEdge({...params, type: 'customStepEdge', data: {controlX: 250, controlY: 200}}, eds),
      ),
    [setEdges],
  );

  const [transform, setTransform] = useState({x: 0, y: 0, zoom: 1});

  // Handle workflow movement and zoom
  const onMove = useCallback(
    (event, viewport) => {
      setTransform(viewport);
    },
    [setTransform],
  );

  return (
    <div style={{width: '100vw', height: '100vh'}}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onEdgesChange={onEdgesChange}
        onNodesChange={onNodesChange}
        onConnect={onConnect}
        onMove={onMove}
        edgeTypes={edgeTypes}
        fitView
        // nodeTypes={nodeTypes}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }}>
        <Background />
        <Controls />
        <MiniMap />
      </ReactFlow>
    </div>
  );
};

export default EditableStepEdgeFlow;
